import React, { useMemo } from "react";
import { Badge } from "react-bootstrap";
import Dialog from "../../../components/Dialog";
import { useAppDispatch } from "../../../hooks/reduxHook";
import useToast from "../../../hooks/useToast";
import {
  fetchGetMe,
  fetchPlayerTroop,
} from "../../../redux/pages/barracks/barracksActions";
import Network from "../../../utils/Network";
import { roundFloat } from "../../../utils/round-float";
import ThousandsSeparator from "../../../utils/thousands-separator";
import { useBarracksUIContext } from "../BarracksContext";
import { useAppTranslation } from "../../../i18n/useAppTranslation";

const UpgradeDialog = () => {
  const axios = new Network();
  const openToast = useToast();
  const { t } = useAppTranslation(["barracks", "common"]);

  const dispatch = useAppDispatch();

  const barracksContext = useBarracksUIContext();
  const barracksUIProps = useMemo(() => {
    return {
      upgradeLoading: barracksContext?.upgradeLoading,
      setUpgradeLoading: barracksContext?.setUpgradeLoading,
      upgradeDialog: barracksContext?.upgradeDialog,
      setUpgradeDialog: barracksContext?.setUpgradeDialog,
    };
  }, [
    barracksContext?.upgradeLoading,
    barracksContext?.setUpgradeLoading,
    barracksContext?.upgradeDialog,
    barracksContext?.setUpgradeDialog,
  ]);

  const handleUpgrade = async (id) => {
    barracksUIProps?.setUpgradeLoading?.(id);
    const response = await axios.CallApi({
      url: `/playertroop/${id}/upgrade/direct`,
    });
    openToast(response);
    if (response.ok) {
      dispatch(fetchPlayerTroop(50));
      dispatch(fetchGetMe());
      barracksUIProps?.setUpgradeDialog?.((prev) => ({
        ...prev,
        open: false,
      }));
    }
    barracksUIProps?.setUpgradeLoading?.(false);
  };

  return (
    <Dialog
      open={!!barracksUIProps?.upgradeDialog?.open}
      title={t("barracks:labels.upgrade")}
      onClose={() =>
        barracksUIProps?.setUpgradeDialog?.((prev) => ({
          ...prev,
          open: false,
        }))
      }
      submitLabel={t("common:actions.yes")}
      closeLabel={t("common:actions.no")}
      loading={barracksUIProps?.upgradeLoading}
      onSubmit={() => handleUpgrade(barracksUIProps?.upgradeDialog?.id)}
    >
      {t("barracks:dialogs.upgrade.confirm")}
      <div
        style={{ marginBottom: -50 }}
        className="d-flex gap-2 mt-3 justify-content-center flex-wrap"
      >
        <Badge
          className="d-flex align-items-center"
          bg={
            barracksUIProps?.upgradeDialog?.cost?.lastClegCost
              ? "danger"
              : "primary"
          }
        >
          <img
            src="/assets/images/icons/cleg.png"
            className="me-1"
            width={25}
            alt="cleg"
          />
          {barracksUIProps?.upgradeDialog?.cost?.lastClegCost !==
          barracksUIProps?.upgradeDialog?.cost?.clegCost ? (
            <span className="d-flex gap-2">
              <small className="text-decoration-line-through">
                {ThousandsSeparator(
                  roundFloat(
                    barracksUIProps?.upgradeDialog?.cost?.lastClegCost ?? 0
                  )
                )}{" "}
                Cleg
              </small>
              <div className=" bold">
                {ThousandsSeparator(
                  roundFloat(
                    barracksUIProps?.upgradeDialog?.cost?.clegCost ?? 0
                  )
                )}{" "}
                Cleg
              </div>
            </span>
          ) : (
            <>
              {ThousandsSeparator(
                roundFloat(barracksUIProps?.upgradeDialog?.cost?.clegCost ?? 0)
              )}{" "}
              Cleg
            </>
          )}
        </Badge>
        <Badge
          className="d-flex align-items-center"
          bg={
            barracksUIProps?.upgradeDialog?.cost?.lastStoneCost
              ? "danger"
              : "primary"
          }
        >
          <img
            src="/assets/images/icons/stone.png"
            className="me-1"
            width={25}
            alt="stone"
          />
          {barracksUIProps?.upgradeDialog?.cost?.lastStoneCost !==
          barracksUIProps?.upgradeDialog?.cost?.stoneCost ? (
            <span className="d-flex gap-2">
              <small className="text-decoration-line-through">
                {ThousandsSeparator(
                  roundFloat(
                    barracksUIProps?.upgradeDialog?.cost?.lastStoneCost ?? 0
                  )
                )}{" "}
                Stone
              </small>
              <div className=" bold">
                {ThousandsSeparator(
                  roundFloat(
                    barracksUIProps?.upgradeDialog?.cost?.stoneCost ?? 0
                  )
                )}{" "}
                Stone
              </div>
            </span>
          ) : (
            <>
              {ThousandsSeparator(
                roundFloat(barracksUIProps?.upgradeDialog?.cost?.stoneCost ?? 0)
              )}{" "}
              Stone
            </>
          )}
        </Badge>

        <Badge
          className="d-flex align-items-center"
          bg={
            barracksUIProps?.upgradeDialog?.cost?.lastIronCost
              ? "danger"
              : "primary"
          }
        >
          <img
            src="/assets/images/icons/metal.png"
            className="me-1"
            width={25}
            alt="metal"
          />
          {barracksUIProps?.upgradeDialog?.cost?.lastIronCost !==
          barracksUIProps?.upgradeDialog?.cost?.ironCost ? (
            <span className="d-flex gap-2">
              <small className="text-decoration-line-through">
                {ThousandsSeparator(
                  roundFloat(
                    barracksUIProps?.upgradeDialog?.cost?.lastIronCost ?? 0
                  )
                )}{" "}
                Iron
              </small>
              <div className=" bold">
                {ThousandsSeparator(
                  roundFloat(
                    barracksUIProps?.upgradeDialog?.cost?.ironCost ?? 0
                  )
                )}{" "}
                Iron
              </div>
            </span>
          ) : (
            <>
              {ThousandsSeparator(
                roundFloat(barracksUIProps?.upgradeDialog?.cost?.ironCost ?? 0)
              )}{" "}
              Iron
            </>
          )}
        </Badge>
      </div>
    </Dialog>
  );
};

export default UpgradeDialog;
